<template>
	<div class="px-md-5">
		<v-layout wrap align-content-space-between class="mb-4">
			<v-flex xs12 md6>
				<h1 class="text--text" style="opacity: .8">Indica-me</h1>
				<p class="mb-0">Utilize o formulário abaixo para gerar um código Indica-me.</p>
			</v-flex>
		</v-layout>
		<Formulario @formulario="generateCode"/>
		<DialogIndicame @closeDialog="closeDialog" :openDialog="openDialog" :code="code"/>
	</div>
</template>

<script>
import { IndicamePresenter } from '@Presenter/indicame-presenter';
import Formulario from './formulario.vue';
import DialogIndicame from './dialog-indicame.vue';

export default {
	data: () => ({
		openDialog: false,
		code: ''
	}),
	components: {
		Formulario,
		DialogIndicame
	},
	methods: {
		generateCode(form) {
			IndicamePresenter.createCode(form.campanha, form.form)
				.then(response => {
					this.code = response.referrerCode;
					this.openDialog = true;
					this.$store.dispatch('SHOW_SNACKBAR', { message: 'Código gerado com sucesso', color: 'success' });
				}).catch(error => {
					let messageSnack = '';
					if (error.message === 'Request failed with status code 422')
						messageSnack = 'Este usuário já possui um código';
					else
						messageSnack = 'Algo deu errado';

					this.$store.dispatch('SHOW_SNACKBAR', { message: messageSnack, color: 'error' });
				});
		},
		closeDialog(value) {
			this.openDialog = value;
		}
	}
};
</script>
